import React from "react";
import {User} from "../../../models/User";
import {PlayerItem, FriendState} from "../PlayerItem";
import {useTranslation} from "react-i18next";

type SearchResultsType = {
    searchResult: User[];
    removeFriend: (user: User) => void;
    sendFriendRequest: (user: User) => void;
    players: User[];
    usersIdWithPendingRequest: User[];
    search: string;
}

export const SearchResults: React.FC<SearchResultsType> = (props) => {
    const {t} = useTranslation();
    
    function getFriendState(userId: number) {
        if (props.players.find(user => user.id === userId)) {
            return FriendState.isFriends;
            
        } else if (props.usersIdWithPendingRequest.find(user => user.id === userId)) {
            return FriendState.isRequestPending;
            
        } else {
            return FriendState.isNotFriends;
        }
    }
    
    return (
        <>
            {props.searchResult.length === 0 ?
                <div className="flex flex-col justify-center items-center h-1/2">
                    <p className="text-2xl">{t("global.no-result-for", {search: props.search})}</p>
                </div>
                :
                <div className={"flex flex-col gap-5"}>
                    {props.searchResult.map((user) => (
                        <PlayerItem
                            key={user.id}
                            user={user}
                            friendState={getFriendState(user.id)}
                            removeFriend={props.removeFriend}
                            sendFriendRequest={props.sendFriendRequest}
                        />
                    ))}
                </div>
            }
        </>
    )
}
